import ShiftDigitalPageType from '~/constants/dealership/ShiftDigitalPageType';

export default function getShiftDigitalPageType(): ShiftDigitalPageType {
  return window.location.pathname === '/'
    ? ShiftDigitalPageType.Home
    : window.location.pathname.startsWith('/cars')
    ? ShiftDigitalPageType.VehicleListing
    : window.location.pathname.startsWith('/service')
    ? ShiftDigitalPageType.Service
    : window.location.pathname.startsWith('/vehicle')
    ? ShiftDigitalPageType.VehicleDetails
    : ShiftDigitalPageType.Other;
}
